import { notifyError } from "../../lib/sentry";

export const getQueryString = (urlString: string): QueryStringObject => {
  try {
    const url = new URL(urlString);
    const queryStringKeys: string[] = Array.from((url.searchParams as URLSearchParam).keys());

    return queryStringKeys.reduce((accum: QueryStringObject, key: string): QueryStringObject => {
      const value = url.searchParams.get(key);
      if (value && !accum[key]) accum[key] = value;
      return accum;
    }, {});
  } catch (e) {
    notifyError(e, { extras: { urlString } });
    return {};
  }
};

export const injectCurrentQueryString = (urlString: string): string => {
  try {
    const currentURL = new URL(window.location.href);
    const url = new URL(urlString);

    currentURL.searchParams.forEach((value: string, key: string): void => {
      if (value && !url.searchParams.get(key)) url.searchParams.set(key, value);
    });

    return url.href;
  } catch (e) {
    notifyError(e, { extras: { urlString } });
    return urlString;
  }
};

type QueryStringObject = Record<string, string>;
interface URLSearchParam extends URLSearchParams {
  keys: () => ArrayLike<string>;
}
